import styled from 'styled-components';

export const ParentTable = styled.div`
  background: ${({ theme }) => theme.palette.white};
  box-shadow: 0px 15px 50px rgba(160, 163, 189, 0.1);
  border-radius: 10px;
  padding: ${({ theme }) => theme.spacing.x3};
`;

export const PageTitle = styled.div`
  h2 {
    margin-bottom: 0 !important;
  }
  @media (max-width: ${({ theme }) => theme.media.xs}) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h2 {
      margin-bottom: ${({ theme }) => theme.spacing.x2} !important;
    }
  }
`;

export const Flex1 = styled.div`
  flex: 1;
`;

export const Products = styled(Flex1)`
  display: flex;
  flex-direction: column;
`;
export const ParentSearch = styled.div`
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  @media (max-width: ${({ theme }) => theme.media.xs}) {
    width: 100%;
  }
`;

// export const Wrapper = styled.div``;
// export const PageTitle = styled.div`
//   margin: ${({ theme }) => theme.spacing.x4} 0px;
// `;

// export const FilightsTableDefult = styled.div`
//   text-align: center;
//   width: 100px;
// `;

// export const FilightsTierTable = styled(FilightsTableDefult)``;

// export const FilightsStatusTable = styled(FilightsTableDefult)``;

// // ---------------head-action----------------
// export const FilightsHeadAction = styled.div`
//   display: flex;
//   align-items: center;
//   @media (max-width: ${({ theme }) => theme.media.lg}) {
//     width: 100%;
//     justify-content: flex-end;
//   }
//   @media (max-width: ${({ theme }) => theme.media.sm}) {
//     width: 100%;
//     justify-content: center;
//   }
// `;
// export const TransActionsHeadActive = styled.div`
//   display: flex;
//   align-items: center;
//   @media (max-width: ${({ theme }) => theme.media.lg}) {
//     width: 100%;
//     justify-content: flex-end;
//   }
// `;

// export const TransActionsHeadActiveButtons = styled.div`
//   margin-inline-start: ${({ theme }) => theme.spacing.x4};
//   @media (max-width: ${({ theme }) => theme.media.sm}) {
//     margin-inline-start: 0px;
//   }
// `;

// export const FilightsHeadActionButtons = styled.div`
//   margin-inline-start: ${({ theme }) => theme.spacing.x4};
//   @media (max-width: ${({ theme }) => theme.media.sm}) {
//     margin-inline-start: 0px;
//   }
// `;

// export const InputParent = styled.div`
//   width: 50%;
//   @media (max-width: ${({ theme }) => theme.media.md}) {
//     width: 100%;
//   }
// `;

// export const containerTitleAndInput = styled.div`
//   display: flex;
//   justify-content: space-between;
//   width: 100%;
//   @media (max-width: ${({ theme }) => theme.media.lg}) {
//     margin-bottom: ${({ theme }) => theme.spacing.x4};
//   }
//   @media (max-width: ${({ theme }) => theme.media.md}) {
//     flex-direction: column;
//   }
// `;

// export const containerTitle = styled.div`
//   @media (max-width: ${({ theme }) => theme.media.lg}) {
//     margin-bottom: ${({ theme }) => theme.spacing.x4};
//   }
// `;

// ///////////////////////////////////////////////

// // ----------------head----------------------

// export const MerchantHead = styled.div`
//   @media (max-width: ${({ theme }) => theme.media.lg}) {
//     flex-direction: column;
//   }
// `;
// export const TitlePageContntainer = styled.div`
//   display: flex;
//   align-items: center;
//   @media (max-width: ${({ theme }) => theme.media.md}) {
//     margin-bottom: ${({ theme }) => theme.spacing.x2};
//   }
// `;

// export const MerchantHeadCount = styled.div`
//   font-size: ${({ theme }) => theme.fs.xxs};
//   margin-inline: ${({ theme }) => theme.spacing.x1};
//   margin-top: 2px;
// `;
// export const MerchantHeadActive = styled.div`
//   display: flex;
//   align-items: center;
//   @media (max-width: ${({ theme }) => theme.media.lg}) {
//     width: 100%;
//     justify-content: flex-end;
//   }
//   @media (max-width: ${({ theme }) => theme.media.xs}) {
//     justify-content: center;
//   }
// `;
// export const MerchantHeadActiveButtons = styled.div`
//   margin-inline-start: ${({ theme }) => theme.spacing.x4};
//   @media (max-width: ${({ theme }) => theme.media.xs}) {
//     margin-inline-start: 0px;
//   }
// `;
